function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.77744 0 0 .7487 17.362 15.276)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "m44.243 119.82c-13.861-12.123-35.429-41.208-39.843-57.015-1.056-3.78-2.384-8.84-2.529-13.334-0.195-6.078 1.081-11.506 1.609-14.943 3.044-19.79 18.79-33.105 40.762-33.105 21.975 0 37.576 13.315 40.621 33.105 0.529 3.438 1.806 8.865 1.609 14.943-0.145 4.494-1.474 9.554-2.529 13.334-4.411 15.807-25.839 44.892-39.7 57.015z"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "44.243 1.421 29.229 15.675 22.562 6.938"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "44.243 21.192 29.459 15.675 26.931 27.63 13.596 32.457 19.344 47.861 30.609 79.357 44.243 92.92 35.667 99.357 30.379 104.65"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "35.437 99.127 16.355 86.023 15.436 63.954 30.609 79.817 35.437 98.898 44.243 119.82"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "6.01 67.402 15.321 64.068 19.344 47.631 26.931 27.859 44.173 21.192"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "29.344 15.675 12.907 14.525 13.596 32.343 4.63 29.584"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "13.596 32.572 1.872 50.39 15.436 64.068"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "44.103 1.421 59.116 15.675 65.872 6.656"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "44.103 21.192 58.887 15.675 61.415 27.63 74.749 32.457 69.002 47.861 57.736 79.357 44.103 92.92 52.68 99.357 57.967 104.65"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "52.909 99.127 71.991 86.023 72.91 63.954 57.829 79.342 52.909 98.898 44.103 119.82"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "82.336 67.402 73.025 64.068 69.002 47.631 61.415 27.859 44.173 21.192"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "59.001 15.675 75.439 14.525 74.749 32.343 83.716 29.584"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "74.749 32.572 86.475 50.39 72.91 64.068"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.77744 0 0 .7487 92.237 15.277)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "m44.243 119.82c-13.861-12.123-35.429-41.208-39.843-57.015-1.056-3.78-2.384-8.84-2.529-13.334-0.195-6.078 1.081-11.506 1.609-14.943 3.044-19.79 18.79-33.105 40.762-33.105 21.975 0 37.576 13.315 40.621 33.105 0.529 3.438 1.806 8.865 1.609 14.943-0.145 4.494-1.474 9.554-2.529 13.334-4.411 15.807-25.839 44.892-39.7 57.015z"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "44.243 1.421 29.229 15.675 22.562 6.938"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "44.243 21.192 29.459 15.675 26.931 27.63 13.596 32.457 19.344 47.861 30.609 79.357 44.243 92.92 35.667 99.357 30.379 104.65"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "35.437 99.127 16.355 86.023 15.436 63.954 30.609 79.817 35.437 98.898 44.243 119.82"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "6.01 67.402 15.321 64.068 19.344 47.631 26.931 27.859 44.173 21.192"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "29.344 15.675 12.907 14.525 13.596 32.343 4.63 29.584"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "13.596 32.572 1.872 50.39 15.436 64.068"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "44.103 1.421 59.116 15.675 65.872 6.656"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "44.103 21.192 58.887 15.675 61.415 27.63 74.749 32.457 69.002 47.861 57.736 79.357 44.103 92.92 52.68 99.357 57.967 104.65"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "52.909 99.127 71.991 86.023 72.91 63.954 57.829 79.342 52.909 98.898 44.103 119.82"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "82.336 67.402 73.025 64.068 69.002 47.631 61.415 27.859 44.173 21.192"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "59.001 15.675 75.439 14.525 74.749 32.343 83.716 29.584"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "74.749 32.572 86.475 50.39 72.91 64.068"
}));

const SvgPearPair = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Foreground",
  width: 178,
  height: 121.33,
  enableBackground: "new 0 0 88 121.333",
  viewBox: "0 0 178 121.33",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPearPair, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pear-pair.eba147bb.svg";
export { ForwardRef as ReactComponent };